import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const InvoiceIcon = (props: SvgIconProps) => {
    const fill = props.fill ?? 'none';

    return (
        <SvgIcon viewBox="0 0 24 24" {...props} fill={fill} sx={{ ...props.sx, fill }}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.5 21H6.5C5.395 21 4.5 20.105 4.5 19V5C4.5 3.895 5.395 3 6.5 3H17.5C18.605 3 19.5 3.895 19.5 5V19C19.5 20.105 18.605 21 17.5 21Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 16.7656H16"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 7.80859V7.05859"
                stroke="currentColor"
                strokeWidth="1.125"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 12.3086V13.0586"
                stroke="currentColor"
                strokeWidth="1.125"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.698 11.7726C10.892 12.0906 11.224 12.3106 11.625 12.3106H12H12.447C13.029 12.3106 13.5 11.8386 13.5 11.2576C13.5 10.7746 13.171 10.3536 12.703 10.2356L11.297 9.88359C10.829 9.76559 10.5 9.34459 10.5 8.86159C10.5 8.28059 10.972 7.80859 11.553 7.80859H12H12.375C12.775 7.80859 13.106 8.02759 13.3 8.34459"
                stroke="currentColor"
                strokeWidth="1.125"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

export default InvoiceIcon;
